import axios from '@/components/plugins/axios'
const url = process.env.VUE_APP_API_URL

class Restaurant {
  getDriverRestaurants () {
    return axios.get(url + '/driver/restaurants')
  }
}
export default new Restaurant()
